import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';

export default {
  name: 'postpaid-purchase',
  props: {
    stripe: {
      type: Object,
    },
    product: {
      type: Object,
      required: true,
    },
    paymentMethod: {
      type: Object,
    },
    priceID: {
      type: String,
      required: true,
    },
    qty: {
      type: Number,
    },
    users: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedPaymentMethod: '',
      isLoading: false,
      error: '',
    };
  },
  computed: {
    activeAccount() {
      return this.$store.getters['account/getActiveAccount'];
    },
  },
  methods: {
    notifyOutcome(outcome, message) {
      const priceNameFormatted = this.product.name;
      const title = outcome ? `Successfully Purchased ${priceNameFormatted}` : `Failed Purchasing ${priceNameFormatted}`;
      const icon = outcome ? 'tick' : 'cross';
      EventBus.$emit('addNotification', {
        title,
        icon,
        message,
      });
    },
    async postPaidPurchase() {
      this.isLoading = true;
      const payload = {
        id: this.activeAccount.uuid,
        name: this.activeAccount.name,
        email: this.userEmail,
        paymentMethodID: 'POSTPAID',
        planID: this.priceID,
        quantity: this.qty,
        users: this.users,
      };


      try {
        const response = await API.post(`${ENDPOINTS.POST_PURCHASE}`, payload);
        if (response.status === 201) {
          this.notifyOutcome(true, response.data.message);
          this.$emit('purchased');
          this.isLoading = false;
          this.$router.push('/').catch();
        } else {
          throw new Error();
        }
      } catch (err) {
        if (err.response && err.response.status === 400) {
          this.notifyOutcome(false, err.response.data.error.errorMessage);
        } else {
          this.notifyOutcome(false, 'Unable to complete payment. Please try again!');
        }
        this.isLoading = false;
      }
    },
  },
};
